function equalizeWidths(element) {
  let elements = document.querySelectorAll(element),
    allWidths = [],
    i = 0

  for(i = 0; i < elements.length; i++){
    elements[i].style.width = 'auto'
  }

  for(i = 0; i < elements.length; i++){
    let elementWidth = elements[i].clientWidth
    allWidths.push(elementWidth)
  }

  for(i = 0; i < elements.length; i++){
    elements[i].style.width = Math.max.apply( Math, allWidths) + 'px'
  }
}

window.addEventListener('load', function () {
  equalizeWidths('.category-alt .category__image')
  equalizeWidths('.benefit .benefit__image')
})

window.addEventListener('resize', function () {
  equalizeWidths('.category-alt .category__image')
  equalizeWidths('.benefit .benefit__image')
})
